<template>
  <div class="mangement_options">
    <a-tabs type="card" @change="callback">
      <a-tab-pane key="1" tab="课程类别">
        <course ref="course"></course>
      </a-tab-pane>
      <a-tab-pane key="2" tab="培训目标">
        <targetpage ref="targetpage"></targetpage>
      </a-tab-pane>
      <a-tab-pane key="3" tab="证书编号">
        <identifier ref="identifier"></identifier>
      </a-tab-pane>
      <!-- <a-tab-pane key="4" tab="自定义考核"> Content of Tab Pane 4 </a-tab-pane> -->
    </a-tabs>
  </div>
</template>

<script>
import course from './modules/course.vue'
import targetpage from './modules/targetPage.vue'
import identifier from './modules/identifier.vue'
export default {
  components: {
    course,
    targetpage,
    identifier,
  },
  data() {
    return {}
  },
  mounted() {
    this.$nextTick((res) => {
      this.$refs.course.init()
    })
  },
  methods: {
    callback(key) {
      this.$nextTick((res) => {
        switch (key) {
          case '1':
            this.$refs.course.init()
            break
          case '2':
            this.$refs.targetpage.init()
            break
          case '3':
            this.$refs.identifier.init()
            break
        }
      })
    },
  },
}
</script>

<style lang="less">
.mangement_options {
  width: 100%;
  height: 100%;
  .ant-tabs-tabpane {
    width: 100%;
    height: 100%;
  }
  .ant-tabs-tabpane-inactive {
    width: 0;
    height: 0;
  }
}
</style>